<template>
  <div class="container">
    <b-modal
        :model-value="showDialogEditGrupo"
        :no-close-on-backdrop="true"
        hide-footer
                centered
        :title="labels.editGroup"
        header-class="reset-modal-header"
        title-class="reset-modal-title"
        body-class="reset-modal-body"
        class="reset-password-dialog edit-grupo-dialog"
     @hide="clicked">
        <div class="uniform-modal-body">
            <div class="password-policy-box mb-4">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-subtitle">{{ labels.infoText }}</div>
            </div>

            <!-- Campo: Seleccionar Grupo -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.selectGroup }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-select
                        v-model="selectedGroupId"
                        :options="groupOptions"
                        class="form-input"
                        @change="onGroupSelected"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                -- {{ labels.selectGroupOption }} --
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>

            <!-- Campo: Nombre -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.name }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="editItem.nombre" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Nombre del grupo"
                        :disabled="!selectedGroupId"
                    />
                </b-col>
            </b-row>

            <!-- Botones de acción -->
            <div class="reset-dialog-actions d-flex justify-content-between mt-4 uniform-actions-wrap">
                <div class="actions-left">
                    <b-button 
                        class="reset-btn-danger" 
                        @click="confirmDelete" 
                        :disabled="!selectedGroupId || isLoading"
                    >
                        <font-awesome-icon :icon="['fas', 'trash']" class="mr-1" />
                        {{ labels.delete }}
                    </b-button>
                </div>
                <div class="actions-right d-flex">
                    <b-button class="reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                    <b-button 
                        class="reset-btn-primary ml-2" 
                        @click="editGrupo" 
                        :disabled="!selectedGroupId || isLoading"
                    >
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>

    <!-- Modal Confirmación Eliminar -->
    <InacticaItem 
        :InactivaItem="showDeleteModal" 
        @confirmDelete="confirmDeleteGrupo" 
        @cierraModal="closeDeleteModal"
    />
  </div>
</template>

<script>
import Grupo from '@/services/Grupo'
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "EditGrupo",
    components: {
        InacticaItem
    },
    props: ['showDialogEditGrupo'],
    data: () => ({
        gruposList: [],
        selectedGroupId: null,
        editItem: {
            id: null,
            nombre: ''
        },
        isLoading: false,
        showDeleteModal: false,
        errors: {
            nombre: ""
        }
    }),
    watch: {
        showDialogEditGrupo(val) {
            if (val) {
                this.cargarGrupos();
                this.resetSeleccion();
            }
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    editGroup: "Editar Grupo",
                    selectGroup: "Seleccionar Grupo",
                    selectGroupOption: "Seleccione un grupo",
                    name: "Nombre",
                    save: "Guardar",
                    close: "Cerrar",
                    delete: "Eliminar",
                    infoTitle: "Datos del grupo",
                    infoText: "Selecciona un grupo y actualiza su información."
                }
            } else {
                return {
                    editGroup: "Edit Group",
                    selectGroup: "Select Group",
                    selectGroupOption: "Select a group",
                    name: "Name",
                    save: "Save",
                    close: "Close",
                    delete: "Delete",
                    infoTitle: "Group information",
                    infoText: "Select a group and update its information."
                }
            }
        },
        groupOptions() {
            return this.gruposList.map((grupo) => ({
                value: grupo.id_grupos || grupo.id,
                text: grupo.nombre
            }))
        }
    },
    methods: {
        async cargarGrupos() {
            this.isLoading = true
            try {
                const result = await Grupo.getAllGrupos()
                this.gruposList = result.data.grupos || []
                
                if (this.gruposList.length === 0) {
                    this.$toast.warning(this.$store.state._language == "es-ES" 
                        ? "No hay grupos disponibles para editar" 
                        : "No groups available to edit")
                }
            } catch (error) {
                console.error("Error loading groups:", error)
                this.$toast.error(this.$store.state._language == "es-ES" 
                    ? "Error al cargar los grupos" 
                    : "Error loading groups")
            } finally {
                this.isLoading = false
            }
        },
        resetSeleccion() {
            this.selectedGroupId = null
            this.editItem = { id: null, nombre: '' }
            this.errors = { nombre: "" }
        },
        onGroupSelected() {
            const selectedGroup = this.gruposList.find(g => (g.id_grupos || g.id) === this.selectedGroupId)
            if (selectedGroup) {
                this.editItem = {
                    id: selectedGroup.id_grupos || selectedGroup.id,
                    nombre: selectedGroup.nombre
                }
                this.errors.nombre = ""
            }
        },
        validateField(field) {
            const lang = this.$store.state._language
            
            if (field === 'nombre') {
                if (!this.editItem.nombre) {
                    this.errors.nombre = lang == "es-ES" 
                        ? "El nombre del grupo es obligatorio" 
                        : "Group name is required"
                } else if (this.editItem.nombre.length < 3) {
                    this.errors.nombre = lang == "es-ES" 
                        ? "El nombre debe tener al menos 3 caracteres" 
                        : "Name must have at least 3 characters"
                } else if (this.editItem.nombre.length > 255) {
                    this.errors.nombre = lang == "es-ES" 
                        ? "El nombre no puede exceder los 255 caracteres" 
                        : "Name cannot exceed 255 characters"
                } else {
                    this.errors.nombre = ""
                }
            }
        },
        validateForm() {
            this.validateField('nombre')
            return !this.errors.nombre
        },
        confirmDelete() {
            if (!this.selectedGroupId) return
            this.showDeleteModal = true
        },
        closeDeleteModal() {
            this.showDeleteModal = false
        },
        confirmDeleteGrupo() {
            this.deleteGrupo()
        },
        async deleteGrupo() {
            this.isLoading = true
            try {
                const res = await Grupo.delete(this.editItem.id)
                
                this.$toast.success(res.data.message || (this.$store.state._language == "es-ES" 
                    ? "Grupo eliminado exitosamente" 
                    : "Group deleted successfully"))
                
                this.showDeleteModal = false
                await this.cargarGrupos()
                this.resetSeleccion()
                this.$emit('grupoActualizado')
                
            } catch (error) {
                console.error("Error deleting group:", error)
                
                let errorMessage = this.$store.state._language == "es-ES" 
                    ? "Error al eliminar el grupo" 
                    : "Error deleting group"
                
                if (error.response && error.response.data) {
                    if (error.response.data.message) {
                        errorMessage = error.response.data.message
                    } else if (error.response.data.error) {
                        errorMessage = error.response.data.error
                    }
                }
                
                this.$toast.error(errorMessage)
            } finally {
                this.isLoading = false
            }
        },
        async editGrupo() {
            if (!this.selectedGroupId) {
                this.$toast.error(this.$store.state._language == "es-ES" 
                    ? "Por favor, seleccione un grupo" 
                    : "Please select a group")
                return
            }
            if (!this.validateForm()) {
                this.$toast.error(this.$store.state._language == "es-ES" 
                    ? "Por favor, corrija los errores del formulario" 
                    : "Please correct the form errors")
                return
            }
            
            this.isLoading = true
            try {
                const grupoData = {
                    nombre: this.editItem.nombre
                }
                
                const res = await Grupo.update(this.editItem.id, grupoData)
                
                this.$toast.success(res.data.message || (this.$store.state._language == "es-ES" 
                    ? "Grupo actualizado exitosamente" 
                    : "Group updated successfully"))
                
                await this.cargarGrupos()
                this.resetSeleccion()
                this.$emit('grupoActualizado')
                this.clicked()
                
            } catch (error) {
                console.error("Error updating group:", error)
                
                let errorMessage = this.$store.state._language == "es-ES" 
                    ? "Error al actualizar el grupo" 
                    : "Error updating group"
                
                if (error.response && error.response.data) {
                    if (error.response.data.message) {
                        errorMessage = error.response.data.message
                    } else if (error.response.data.error) {
                        errorMessage = error.response.data.error
                    }
                }
                
                this.$toast.error(errorMessage)
            } finally {
                this.isLoading = false
            }
        },
        clicked() {
            this.resetSeleccion()
            this.$emit('clicked', false)
        }
    }
}
</script>

<style src="../main.css"></style>